import { configureStore } from '@reduxjs/toolkit'
import { createBrowserHistory } from 'history'

import { middle } from '../io/middle'
import createRootReducer from '../reducer'

export const history = createBrowserHistory()
const __DEV__ = import.meta.env.__DEV__
// console.log(__DEV__)
// debugger
export const appConfigureStore = (preloadedState = {}) => {
  const store = configureStore({
    reducer: createRootReducer(history),

    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // Optional: Customize default middleware
        // immutableCheck: false,    // 👈 Turn off completely for testing
        // serializableCheck: false, // 👈 Turn off completely for testing
        serializableCheck: {
          // Ignore these action types / paths if you have non-serializable data (e.g. history, sockets)
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
          ignoredPaths: ['some.socket', 'router'],
        },
        // immutableCheck: process.env.NODE_ENV !== 'production',
        immutableCheck: __DEV__,
      }).concat(middle),
      // }).prepend(middle),

    preloadedState,

    devTools: __DEV__,
  })
  // store.dispatch({ type: 'init', test: 'Does this hit middle?' });
  return store
}

export default appConfigureStore
